import type { WorkflowDefWithData } from '~/hooks/submittals'

export const getStepCounter = (completionStatus: boolean[] | null) => {
  if (!completionStatus) return '0/? Completed'

  if (
    !Array.isArray(completionStatus) &&
    typeof completionStatus === 'boolean' &&
    completionStatus
  ) {
    return '1/1 Completed'
  }

  const completed = completionStatus.filter(Boolean).length
  const total = completionStatus.length
  return `${completed}/${total} Completed`
}

export const getButtonLabel = (completionStatus: boolean[] | null) => {
  if (!completionStatus) return 'Start'

  if (
    !Array.isArray(completionStatus) &&
    typeof completionStatus === 'boolean' &&
    completionStatus
  ) {
    return 'Completed'
  }

  if (
    !Array.isArray(completionStatus) &&
    typeof completionStatus === 'boolean' &&
    completionStatus === false
  ) {
    return 'Start'
  }

  if (completionStatus.every((action) => action === false)) return 'Start'
  if (completionStatus.every((action) => action === true)) return 'Completed'
  return 'Continue'
}

export const isStepEnabled = (
  workflowWithData: WorkflowDefWithData,
  currentStepIndex: number
): boolean => {
  if (!workflowWithData?.steps?.[currentStepIndex]) {
    return false
  }

  const currentStep = workflowWithData.steps[currentStepIndex]

  // If there are no dependencies or depends_on is undefined, the step is enabled
  if (!currentStep.depends_on || currentStep.depends_on.length === 0) {
    return true
  }

  // Check if all dependencies are completed
  return currentStep.depends_on.every((dependencyIndex: number) => {
    const dependencyStep = workflowWithData.steps[dependencyIndex]

    // If the dependency step doesn't exist, return false
    if (!dependencyStep) {
      return false
    }

    // Check if the dependency step is completed
    const completionStatus =
      typeof dependencyStep.state.completion_status === 'boolean'
        ? [dependencyStep.state.completion_status]
        : dependencyStep.state.completion_status

    return completionStatus?.every((status: boolean) => status === true) ?? false
  })
}
